import { Page } from "@/models/page-models/Page";

export const ProductMaster: Page = {
  "path": "product-master",
  "name": "Product",
  "props": {
    "data": {
      "title": "Product",
      "printable": "FALSE",
      "url": "product-master",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customerId",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToCustomerProductMaster",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/product-master/{{formData.customerId}}"
                      },
                      "name": "redirectToCustomerProductMaster"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Create New Product",
                  "disabled": "TRUE",
                  "showIf": "fn(MATCH_DEPARTMENT,SALES)"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Open",
              "bracketValueFormula": "{{fetchedData.openProducts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Products",
                      "disabled": "FALSE",
                      "items": "fetchedData.openProducts.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Product #",
                          "type": "url",
                          "url": "/products/{{__item._id}}"
                        },
                        {
                          "value": "productLine",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                        },
                        {
                          "value": "customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,productStatus,{{__item}},false)"
                        },
                        {
                          "value": "lastInvoicedAt",
                          "text": "Last Invoiced",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.lastInvoicedAt}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Created On",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.openProductsForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultPageNo"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copySearchKey",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.openProductsForm.q.pattern"
                          },
                          "name": "copySearchKey"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                              "name": "getOpenProducts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/product/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.openProductsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.openProducts"
                            },
                            "name": "getOpenProducts"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Close",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),||,fn(MATCH_ROLE,QA_MANAGER))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDisabled",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/product/{{__item._id}}/mark-disabled",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "markProductAsDisabled"
                            }
                          ]
                        },
                        {
                          "label": "Reactivate",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "reactivateProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/activate",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "reactivateProduct"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openProductsForm.page",
                        "serverItemsLengthVariable": "fetchedData.openProducts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.openProductsForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenProducts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/product/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.openProductsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.openProducts"
                            },
                            "name": "getOpenProducts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending",
              "bracketValueFormula": "{{fetchedData.pendingProducts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Products",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.pendingProducts}}",
                      "items": "fetchedData.pendingProducts.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Product #",
                          "type": "url",
                          "url": "/products/{{__item._id}}"
                        },
                        {
                          "value": "productLine",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                        },
                        {
                          "value": "customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "lastInvoicedAt",
                          "text": "Last Invoiced",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.lastInvoicedAt}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Created On",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "approveProduct"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,QA_TECHNICAL_EXECUTIVE)),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDraft",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/mark-as-draft",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "markProductAsDraft"
                            }
                          ]
                        },
                        {
                          "label": "Close",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDisabled",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/product/{{__item._id}}/mark-disabled",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "markProductAsDisabled"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingproductsForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingProducts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingProductsForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingProducts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/product/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.pendingProductsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.pendingProducts"
                            },
                            "name": "getPendingProducts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Draft",
              "bracketValueFormula": "{{fetchedData.draftProducts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Draft Products",
                      "disabled": "FALSE",
                      "items": "fetchedData.draftProducts.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Product #",
                          "type": "url",
                          "url": "/products/{{__item._id}}"
                        },
                        {
                          "value": "productLine",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                        },
                        {
                          "value": "customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "lastInvoicedAt",
                          "text": "Last Invoiced",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.lastInvoicedAt}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Created On",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Submit",
                          "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),||,fn(MATCH_ROLE,Sales | Account Executive))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "submitProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/submit",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "submitProduct"
                            }
                          ]
                        },
                        {
                          "label": "Close",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDisabled",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/product/{{__item._id}}/mark-disabled",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "markProductAsDisabled"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.draftProductsForm.page",
                        "serverItemsLengthVariable": "fetchedData.draftProducts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.draftProductsForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getDraftProducts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/product/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.draftProductsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.draftProducts"
                            },
                            "name": "getDraftProducts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Closed",
              "bracketValueFormula": "{{fetchedData.inactiveProducts.data.totalDocs}}",
              "rows": [
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Products List",
                      "disabled": "FALSE",
                      "items": "fetchedData.inactiveProducts.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Product #",
                          "type": "url",
                          "url": "/products/{{__item._id}}"
                        },
                        {
                          "value": "productLine",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                        },
                        {
                          "value": "customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "lastInvoicedAt",
                          "text": "Last Invoiced",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.lastInvoicedAt}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Created On",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "tableType": "static",
                      "canDelete": false,
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultPageNo",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultPageNo",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.inactiveProductForm",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyDefaultPageNo"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copySearchKey",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.inactiveProductForm.q.pattern"
                          },
                          "name": "copySearchKey"
                        },
                        {
                          "executionOrder": 3,
                          "name": "getInactiveProducts"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Reactivate",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_DEPARTMENT,SALES))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "reactivateProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/activate",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "reactivateProduct"
                            }
                          ]
                        },
                        {
                          "label": "Delete",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "deleteProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/delete",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH"
                              },
                              "name": "deleteProduct"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getInactiveProducts",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Create Duplicate",
                          "showIf": "fn(MATCH_DEPARTMENT,SALES)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),!==,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openProductDuplicatePage",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/products/create",
                                "arg2Key": "queryParams",
                                "arg2Value": "{\"customer\":\"{{formData.customerId}}\",\"duplicate\":\"{{__item._id}}\"}"
                              },
                              "name": "openProductDuplicatePage"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.inactiveProductForm.page",
                        "serverItemsLengthVariable": "fetchedData.inactiveProducts.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "name": "getInactiveProducts"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.inactiveProductForm.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingProductsParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingProductsParams",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingProductsForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingProductsParams"
      },
      {
        "executionOrder": 2,
        "name": "getPendingProducts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultDraftProductsParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultDraftProductsParams",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.draftProductsForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultDraftProductsParams"
      },
      {
        "executionOrder": 2,
        "name": "getDraftProducts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenProductsParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenProductsParams",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openProductsForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenProductsParams"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
            "name": "getOpenProducts",
            "type": "fnGetData",
            "arg1Key": "apiUrl",
            "arg1Value": "/api/v1/product/search",
            "arg2Key": "postData",
            "arg2Value": "fetchedData.openProductsForm",
            "arg3Key": "storeInVar",
            "arg3Value": "fetchedData.openProducts"
          },
          "name": "getOpenProducts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyInactiveProductsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getInactiveProductsForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.inactiveProductForm"
        },
        "name": "copyInactiveProductsForm"
      },
      {
        "executionOrder": 2,
        "name": "getInactiveProducts"
      }
    ],
    "functions": [
      {
        "name": "getInactiveProducts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/product/search",
        "arg2Key": "postData",
        "arg2Value": "fetchedData.inactiveProductForm",
        "arg3Key": "storeInVar",
        "arg3Value": "fetchedData.inactiveProducts"
      },
      {
        "name": "getInactiveProductsForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": ["Closed" ]
          },
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingProductsParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultDraftProductsParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Draft"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultOpenProductsParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Open"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getPendingProducts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/product/search",
        "arg2Key": "postData",
        "arg2Value": "fetchedData.pendingProductsForm",
        "arg3Key": "storeInVar",
        "arg3Value": "fetchedData.pendingProducts"
      },
      {
        "name": "getDraftProducts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/product/search",
        "arg2Key": "postData",
        "arg2Value": "fetchedData.draftProductsForm",
        "arg3Key": "storeInVar",
        "arg3Value": "fetchedData.draftProducts"
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Open Prospect", "Open Customer", "Closed Prospect", "Closed Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,CUSTOMER_SERVICE_ARTWORK,CUSTOMER_SERVICE_MANAGER,ACCOUNTING_COSTING,GENERAL_MANAGER,QA_MANAGER,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE",
  "visible": true,
  "routerPriority": 75
}